module.exports = __webpack_public_path__ + "static/christmas_childplay_19...4.686bb325.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/images/project3/christmas_childplay_19...4.jpg
// module id = 504
// module chunks = 142966368958528